export const EVENT_WELLBEING_CHECKER_COMPLETED = "wellbeing_checker";
export const EVENT_RECORD_MOOD = "mood_record";
export const EVENT_HABIT_ADD = "habit_add";
export const EVENT_ADD_JOURNAL = "journal_add";
export const EVENT_RECORD_FEELINGS = "feelings_record";
export const EVENT_BREATHING_EXERCISE = "breathing_exercise";
export const EVENT_GET_GROUNDED = "get_grounded";
export const EVENT_NOTIFICATIONS_ENABLED = "notifications_enabled";
